import { Button, Tooltip } from '@wix/design-system';
import React from 'react';
import s from './SelectProductButton.scss';
export const SelectProductButton = ({ text, onClick, disabledText, fullWidth, size, dataHook, disabled, skin = 'premium', priority = 'secondary', }) => {
    const shouldShowTooltip = disabled && disabledText;
    return (React.createElement(Tooltip, { placement: "bottom", content: disabledText, className: s.tooltip, disabled: !shouldShowTooltip },
        React.createElement(Button, { fullWidth: fullWidth, onClick: onClick, priority: priority, disabled: disabled, dataHook: dataHook, skin: skin, size: size }, text)));
};
//# sourceMappingURL=SelectProductButton.js.map